/**
 * UUIDv4 generation per Idempotency-Key (CLAUDE.md §9 + Phase 2 §05).
 *
 * Usiamo `crypto.randomUUID()` nativo (Node 19+ / Chrome 92+ / Safari 15.4+).
 * Fallback non e' necessario: il target deployment e' un'app dietro nginx,
 * tutti i client moderni hanno supporto.
 */

export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}

/** Validazione formato UUID v4 (per test fixtures + utility). */
const UUID_V4_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUuidV4(value: string): boolean {
  return UUID_V4_RE.test(value);
}
